import { BecomeAdvisorLandingLayout } from '@src/components/sco/Advisors'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'

export { getServerSideProps } from '@src/lib/server-side-rendering'

/**
 * Public landing for people who want to become startup advisors.
 * Always shows the marketing page; CTAs send guests through signup/login
 * and land registered users on /advisors/apply.
 */
export default function Page() {
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('advisors.become-a-startup-advisor')
    activeContent.setItem({
      __typename: 'LandingPage',
      title: 'Become a Startup Advisor',
      description:
        'Join the Startups.com advisor network. Take board seats for equity, get paid for sessions, and get matched to founders who need your expertise.',
    })
    return () => activeContent.setItem(null)
  }, [])

  return <BecomeAdvisorLandingLayout />
}
